import React from 'react';
import MainInfoTracLayout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/ReverseMailTracking/SearchResult';

function ReverseMailSearchResult() {
  return (
    <MainInfoTracLayout>
      <Content />
    </MainInfoTracLayout>
  );
}

export default ReverseMailSearchResult;
